module.exports = __webpack_public_path__ + "img/redbeard-ventures.8eaf580b.png";